export const navbar = [
    {
        name: '¿Quiénes somos?',
        path: '#',
        subitems: [
            { name: 'Nuestra historia', path: 'quienes-somos' },
            { name: 'Misión', path: 'quienes-somos' },
            { name: 'Visión', path: 'quienes-somos' },
        ]
    },
    {
        name: 'Servicios',
        path: '#',
        subitems: [
            { name: 'Préstamos al instante', path: 'servicios' }
        ]
    },
    { name: 'Beneficios', path: 'beneficios' },
    { name: 'Testimonios', path: 'testimonios' },
    { name: 'Blog', path: 'blog' },
    { name: 'Noticias', path: 'noticias' },
    {
        name: 'Ayuda',
        path: '#',
        subitems: [
            { name: 'Preguntas frecuentes', path: 'ayuda' },
            // { name: 'Contacto', path: 'contactenos' },
        ]
    },
]
